import React from "react";
import { Link } from "gatsby"
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Logo from "../../images/logo.png";
import {useSiteMetadata} from "../../branding";
import { TOOLS, getToolIcon, getToolLink, getToolDisplayName } from "../../optiontools";
import "../../css/icons/font-awesome/css/fontawesome.css";
import "../../css/icons/font-awesome/css/fa-solid.css";

const LeftNavHeader = (props) => {
    const theme=useTheme();
    return <Box sx={{display: 'flex',
              alignItems: 'center',
              padding: theme.spacing(0, 1),
              ...theme.mixins.toolbar,// necessary for content to be below app bar
              justifyContent: 'center',}}>
                <img src={Logo} height={theme.mixins.toolbar.minHeight} alt="optiontrader.tools" />
            </Box>;
}

const LeftNavFooter = (props) => {
    const siteMetadata = useSiteMetadata();
    const theme=useTheme();
    const drawerWidth=props.drawerWidth;
    return  <Box position="fixed" 
                sx={{top: 'auto', bottom: 0,
                    //derived from ...theme.mixins.toolbar, with addition of width property in @media queries:
                    minHeight:56,
                    "@media (min-width:0px)":{"minHeight":64, "width":`${drawerWidth}px`},
                    "@media (min-width:600px)":{ "minHeight":64, "width":`${drawerWidth}px`}
                    }}
            >
            <Divider/>
            <Box sx={{display:"flex",marginTop:"0px",marginBottom:"0px",...theme.mixins.toolbar,alignItems:"center",justifyContent:"center"}}>
            2026 © {siteMetadata.title}
            </Box>
    </Box>;
}


const NavButton = ({ toolKey }) => {
    const icon = getToolIcon(toolKey);
    const to = getToolLink(toolKey);
    const toolName = getToolDisplayName(toolKey);
    const [isHovered, setIsHovered] = React.useState(false);
    
    return (
        <Link 
            to={to}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 12px',
                textDecoration: 'none',
                color: '#666',
                backgroundColor: isHovered ? '#f8f9fa' : 'transparent',
                borderRadius: '8px',
                transition: 'all 0.2s ease',
                width: '100%',
                fontSize: '0.875rem',
                fontWeight: 500,
                cursor: 'pointer',
                transform: isHovered ? 'translateX(4px)' : 'translateX(0)',
                boxShadow: isHovered ? '0 2px 8px rgba(0,0,0,0.08)' : 'none'
            }}
            activeStyle={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
            }}
        >
            {icon && (
                <span style={{ 
                    fontSize: '16px', 
                    display: 'flex', 
                    alignItems: 'center',
                    minWidth: '16px',
                    transition: 'transform 0.2s ease',
                    transform: isHovered ? 'scale(1.1)' : 'scale(1)'
                }}>
                    {icon}
                </span>
            )}
            <span>{toolName}</span>
        </Link>
    );
};

const LeftNav=(props)=> {
    const drawerWidth=props.drawerWidth;
    
    const toolsList = [
        TOOLS.MARKET_OVERVIEW,
        TOOLS.TICKER_REPORT,
        TOOLS.MAX_PAIN,
        TOOLS.OPTION_PRICER,
        TOOLS.SPREAD_FINDER,
        TOOLS.CONDOR_BUILDER,
        TOOLS.PUT_CALL_RATIOS,
        TOOLS.CHAT
    ];
    
    return <>
            <Box component="div" >
                <LeftNavHeader />
                <Divider />
                <List>
                    {toolsList.map((toolKey) => (
                        <ListItem key={toolKey} style={{ padding: '4px 8px' }}>
                            <NavButton toolKey={toolKey} />
                        </ListItem>
                    ))}
                </List>   
            </Box>
            <LeftNavFooter drawerWidth={drawerWidth}  />
        </>;
  };

export default LeftNav;